module.exports = __webpack_public_path__ + "fonts/DINRoundPro.eot?756178cd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINRoundPro.eot
// module id = 786
// module chunks = 0 1 2 3 4 5